/**
 * Remet les lignes d'un document dans l'ordre saisi par l'utilisateur.
 *
 * Un embed PostgREST (`..._document_lines(*)`) n'a PAS d'ORDER BY : le serveur
 * renvoie les lignes dans l'ordre du plan, c'est-a-dire l'ordre PHYSIQUE des
 * tuples. Or la RPC de mise a jour reecrit les lignes survivantes
 * (`UPDATE ... SET line_number = ordinality`) : chaque UPDATE cree une nouvelle
 * version du tuple en fin de tas, donc une ligne non touchee par la derniere
 * edition se retrouve devant toutes les autres. D'ou le symptome client : on
 * enregistre un document, on le rouvre, un article a saute en tete de liste.
 *
 * `line_number` reste juste en base — c'est la LECTURE qui l'ignorait. Trier
 * ici (et non dans la requete) garde l'invariant vrai pour tout adaptateur, y
 * compris le futur Spring Boot.
 *
 * Le `id` en second critere rend l'ordre TOTAL : la prod porte quelques paires
 * (document_id, line_number) en double, qui sinon garderaient l'ordre physique
 * instable renvoye par le transport.
 */
export function sortByLineNumber<T extends { lineNumber: number; id: string }>(
  lines: readonly T[],
): T[] {
  return [...lines].sort(
    (a, b) => a.lineNumber - b.lineNumber || a.id.localeCompare(b.id),
  );
}
